
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { UtilsService } from '../utils.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { LeadsConstants } from 'src/app/constants/leads';
import { ApiApiceService } from '../api/api-apice.service';
import { CalcViagem } from 'src/app/models/calcViagem.model';
import { ApiInterfaceService } from '../api/api-interface.service';

@Injectable({
  providedIn: 'root'
})

export class CotacaoViagemService implements CotacaoRamoService {

  public _leadsCadastrados = LeadsConstants.leads;
  public _seguradorasBase = IntegracaoConstants.seguradoras;
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private _packageType = IntegracaoConstants.packageType;

  private tipoReq = 5;
  public dadosUser: any = []
  private optionsViagem = null;

  constructor(private utilsService: UtilsService, private api: ApiApiceService) { }

  async setDadosUser(){
    try{
        this.optionsViagem = await this.api.getOptionsViagem()
    }catch(err){
      console.log(err)
    }
  }

  sessoesPDF() {
    return [{
      code: 1,
      description: "Segurado",
      selected: true
    },
    {
      code: 2,
      description: "Dados da Viagem",
      selected: true
    },
    {
      code: 4,
      description: "Cálculos com erro",
      selected: true
    }]
  }

  setComissaoDefault(su) {
    su.percComissao = su.percComissaoViagem ? su.percComissaoViagem : 0;
    su.percDesconto = su.percDescontoViagem ? su.percDescontoViagem : 0;
    return su;
  }

  setCoberturas(v, obj) {
    return null;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO_VIAGEM';
  }

  getColumnsGridCalculosVersao() {
    return [
      'seguradora',
      'premio',
      'comissao',      
      'isDespesasMedicasHospitalares',
      'morteAcidental',
      'invalidezPermanente',
      'danosBagagem',
      'funeral',
      'tempo'
    ];
  }

  getCalcObject(draft, seguradoras, coberturas) {
    let obj = JSON.parse(JSON.stringify(draft));

    obj.ramo = this._ramos.VIAGEM;
    obj.tipo = 5;

    let hoje = new Date();
    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
      }

    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo });
    obj.calculos = obj.calculos.map(function (el) {
      let objCalc = { ...el, ...this.coberturasCalc };
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? parseInt(el.percDesc) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelecimento)
        objCalc.libertyCodigoEstabelecimento = null;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;

      delete objCalc.ID;

      return objCalc;

    }.bind(this));

    return obj;

  }

  coberturasMerge(coberturas, obj) {
    return coberturas;
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, ramo) {
    let segStatus = servicesInfos.calculos.vida.viagem;

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {
        if (seguradorasUser) {
          let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora });

          if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id) {

            seg.idIntegracaoCfg = seg.ID;
            seg.idIntegracaoCfgSeg = seg.ID;

            seg.login = seg.usuario;

            seg.percCom = seg.percComissao;
            seg.percDesc = seg.percDesconto;

            let cfgSegConfig = { ...option, ...seg };

            filtered.push(cfgSegConfig);

          }
        }

        return filtered;
      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  async getCoberturasUser(api) {
    return null;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == "next") {
          return "enviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == "next") {
          return "simuladorComissoes";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          if (flags.simuladorComissoes) {
            return "simuladorComissoes";
          } else if (flags.calcular) {
            return "resultados";
          } else {
            return "formulario"
          }
        }
        break;
    }
  }

  //adaptado para o apice
  createDraft(negocio, opt?) {
    if (!negocio)
      negocio = new CalcViagem();
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          "nome",
          "cpfCnpj",
          "dataNasc",
          "fone1",
          "fone",
          "email"
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }
    return negocio;
  }

  createVersions(arrayVersions) {
    return arrayVersions.map((v) => {

      //Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      //Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.
      if (!v.versao && v.versao !== 0)
        v.versao = 1;

      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });
  }

  private addVersion(v) {

    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);
    v.vigenciaFimTxt = this.utilsService.dateStringToTxt(v.vigenciaFim);
    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);

    v.results = new CalcsResults();

    this.updateResults(v);

  }

  public updateResults(v) {
    v.calculos.map((vr) => {
      this.extractResultsViagem(v, vr);
    });

    this.utilsService.setResultsAll(v);
    this.utilsService.sortResults(v);
  }

  private extractResultsViagem(v, calc) {

    delete calc['corretora'];

    let id = 0;

    v.configuracoes.motivoTxt = v.configuracoes?.motivo ? this.getOption('Motivo', v.configuracoes?.motivo) : "--";
    const meioTransporteArray = v.configuracoes?.meioTransporte ? v.configuracoes?.meioTransporte.split(',') : null;
    v.configuracoes.meioTransporteTxt = meioTransporteArray ? this.getMeioTransporte(meioTransporteArray) : "--";
    v.configuracoes.tipoTxt = v.configuracoes?.tipo ? this.getOption('Tipo', v.configuracoes?.tipo) : "--";
    v.configuracoes.origemTxt = v.configuracoes?.origem ? this.getOrigemDestino(1, v.configuracoes?.origem) : "--";
    v.configuracoes.destinoTxt = v.configuracoes?.destino ? this.getOrigemDestino(v.configuracoes?.tipo, v.configuracoes?.destino) : "--";
    v.configuracoes.totalPassageirosTxt = v.configuracoes?.totalPassageiros ? v.configuracoes?.totalPassageiros : "--";
    v.configuracoes.esporteRadicalViagemTxt = v.configuracoes?.esporteRadicalViagem ? "Sim" : "Não";
    v.configuracoes.motocicletaViagemTxt = v.configuracoes?.motocicletaViagem ? "Sim" : "Não";
    if (v.configuracoes?.tipo == 2) {
      v.configuracoes.visitaEuropaTxt = v.configuracoes?.visitaEuropa ? "Sim" : "Não";
     }
    const idadeArray = v.configuracoes?.idade ? v.configuracoes?.idade.split(',') : null;
    v.configuracoes.idadeTxt = idadeArray ? this.getIdade(idadeArray) : "--";

    let iterarCalcs = calc.resultados;

    if (!Array.isArray(iterarCalcs) || iterarCalcs.length == 0) {
      let copyToResult = JSON.parse(JSON.stringify(calc));
      copyToResult.principal = true;
      iterarCalcs = [copyToResult];
    }

    if (iterarCalcs) {

      iterarCalcs.map(function (vrr) {
        id = id + 1;
        vrr.ramo = this.ramo;
        vrr.retorno = calc.retorno;
        vrr.idPacote = calc.seguradora + "-" + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);
        vrr.tempoResposta = calc.tempoResposta ? calc.tempoResposta / 1000 : "";
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;
        vrr.seguradora = calc.seguradora;

        vrr.isComissaoAdicional = vrr.comissaoAdicional ? true : false;
        if (vrr.isComissaoAdicional)
          vrr.comissaoAdicionalTxt = this.utilsService.numberFormat(vrr.comissaoAdicional);

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Principal";
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Alternativo";
        }

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, "$1...")
        }

        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;
        if (vrr.hasOwnProperty('idCalculo'))
          vrr.nroCalculo = vrr.idCalculo;

        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : "--";
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : "--";

        if (vrr.coberturas) {
          vrr.coberturas.percDescontoTxt = vrr.coberturas.percDesconto ? (vrr.coberturas.percDesconto + "%") : "--";
          vrr.coberturas.percDesconto = vrr.coberturas.percDesconto ? vrr.coberturas.percDesconto : "--";

          vrr.coberturas.percComissaoTxt = vrr.coberturas.percComissao ? (vrr.coberturas.percComissao + "%") : "--";

          const fields = [
            'morteAcidental', 'invalidezPermanente', 'funeral',
            'isDespesasMedicasHospitalares', 'cancelamento', 'interrupcao', 'extravioBagagem', 'danosBagagem',
            'trasladoCorpo', 'trasladoMedico', 'regressoSanitario', 'retornoSegurado', 'retornoFamiliar',
            'retornoAcompanhante', 'retornoMenores', 'acompanhanteHospitalizacao', 'hospedagemAcompanhante',
            'acompanhamentoMenor', 'fisioterapia', 'assistenciaFarmaceutica', 'assistenciaJuridica',
            'pagamentoFianca', 'prorrogacaoEstada', 'atrasoBagagem', 'atrasoEmbarque'
          ];
        
          fields.forEach(field => {
            const [txt, txtRS] = this.formataRetornoValor(vrr.coberturas[field]);
            vrr.coberturas[field + 'Txt'] = txt;
            vrr.coberturas[field + 'TxtRS'] = txtRS;
          });
        } else {
          vrr.coberturas = {};
        }

        vrr.msErros = calc.erros;
        vrr.msAlertas = calc.alertas;

        if (vrr.alertas)
          vrr.msAlertas = Array.isArray(vrr.msAlertas) ? vrr.msAlertas.concat(vrr.alertas) : vrr.alertas;

        let verificarPremio = vrr.premio && vrr.premio > 0;

        if (vrr.retorno && !vrr.isError && !verificarPremio) {
          vrr.isError = true;
          vrr.msErros = ["Houve um erro não identificado ao realizar este cálculo."];
        }

        let arrToAdd = vrr.isError ? "errors" : "successes";
        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);

          if (vrr.principal && !isAlternative) {
            vrr.isAlternative = false;
            v.results.main[arrToAdd].push(vrr);
          } else if ((!vrr.isError) || isAlternative) {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        }

      }.bind(this));

    }
  }

  formataRetornoValor(value: string | number | undefined): [string, string] {
    if (value !== undefined) {
      let valueWithSymbol;
      let valueWithoutSymbol;
      if (typeof value === 'number') {
        valueWithoutSymbol = this.utilsService.numberFormat(value, false); 
        valueWithSymbol = this.utilsService.numberFormat(value, true);
      } else if (typeof value === 'string') {
        valueWithoutSymbol = value.replace(/[^0-9,.-]/g, '').trim();
        valueWithSymbol = value;
      }

      return [valueWithoutSymbol, valueWithSymbol];
    }
    return ["--", ""];
  }

  getOption(optionName, value) {
    let op = this.optionsViagem?.[optionName]
    if (op) {
      let ditCob = op.find(d => {
        return d.Key === value
      })
  
      return ditCob?.Value ? ditCob?.Value : ''
    }
    return '';
  }

  getMeioTransporte(value: string[]): string {
    const resultado = value
      .map(valor => this.getOption("MeioTransporte", valor))
      .filter(viewValue => viewValue !== '');

    if (resultado.length > 1) {
      const ultimo = resultado.pop();
      return `${resultado.join(', ')} e ${ultimo}`;
    } else {
      return resultado.join(', ');
    }
  }

  getIdade(value: number[]): string {
    const resultado = value.map(valor => `${valor}`);

    if (resultado.length > 1) {
      const ultimo = resultado.pop() + ' anos';
      return `${resultado.join(', ')} e ${ultimo}`;
    } else {
      return resultado.join('') + ' anos';
    }
  }

  getOrigemDestino(tipo, value) {
    let name = tipo == 1 ? 'Estado' : 'Pais'
    let op = this.optionsViagem?.[name]
    if (op) {
      let ditCob = op.find(d => {
        return d.Id === value
      })

      return ditCob?.Nome ? ditCob?.Nome : ''
    }
    return '';
  }

}
